import { Layout } from 'antd';
import React, { useState } from 'react';

import {
    BackToModesLink,
    CITY_POOL,
    CityNameWithCoatOfArms,
    EXTENDED_TOTAL_ROUNDS,
    Header,
    KRAJ_NAMES,
    OKRES_NAMES,
    OptionButton,
    OptionGrid,
    Page,
    Question,
    QuizFinalResult,
    QuizPanel,
    RoundResultModal,
    RoundStatus,
    makeOptions,
    pickRandom,
} from '../../components/quiz';

const { Content } = Layout;

const makeQuestion = () => {
    const city = pickRandom(CITY_POOL);
    const type = Math.random() > 0.5 ? 'kraj' : 'okres';
    const correctAnswer = type === 'kraj' ? city.kraj : city.okres;
    const allAnswers = type === 'kraj' ? KRAJ_NAMES : OKRES_NAMES;

    return {
        city,
        type,
        correctAnswer,
        options: makeOptions(correctAnswer, allAnswers),
    };
};

const MunicipalityRegionGame = () => {
    const [round, setRound] = useState(1);
    const [score, setScore] = useState(0);
    const [question, setQuestion] = useState(makeQuestion);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [rounds, setRounds] = useState([]);
    const [finished, setFinished] = useState(false);

    const maxScore = EXTENDED_TOTAL_ROUNDS * 100;
    const isCorrect = selectedAnswer === question.correctAnswer;

    const restart = () => {
        setRound(1);
        setScore(0);
        setQuestion(makeQuestion());
        setSelectedAnswer(null);
        setModalVisible(false);
        setRounds([]);
        setFinished(false);
    };

    const answer = option => {
        if (selectedAnswer) return;
        setSelectedAnswer(option);
        const correct = option === question.correctAnswer;
        if (correct) setScore(s => s + 100);
        setRounds(prev => [
            ...prev,
            { correct, score: correct ? 100 : 0, label: `${question.city.obec} → ${question.correctAnswer}` },
        ]);
        setModalVisible(true);
    };

    const advanceRound = () => {
        setModalVisible(false);
        setRound(r => r + 1);
        setQuestion(makeQuestion());
        setSelectedAnswer(null);
    };

    const showFinal = () => {
        setModalVisible(false);
        setFinished(true);
    };

    if (finished) {
        return (
            <QuizFinalResult score={score} totalRounds={EXTENDED_TOTAL_ROUNDS} rounds={rounds} onRestart={restart} />
        );
    }

    return (
        <>
            <QuizPanel>
                <RoundStatus round={round} score={score} maxScore={maxScore} totalRounds={EXTENDED_TOTAL_ROUNDS} />
                <Question>
                    <p>Kraj / okres k obci</p>
                    <h2>
                        <CityNameWithCoatOfArms city={question.city} size={58} />
                    </h2>
                    <p>
                        {question.type === 'kraj'
                            ? 'Do kterého kraje tahle obec patří?'
                            : 'Do kterého okresu tahle obec patří?'}
                    </p>
                </Question>
                <OptionGrid>
                    {question.options.map(option => (
                        <OptionButton
                            key={option}
                            answer={option}
                            correctAnswer={question.correctAnswer}
                            disabled={!!selectedAnswer}
                            selectedAnswer={selectedAnswer}
                            onClick={() => answer(option)}
                        />
                    ))}
                </OptionGrid>
            </QuizPanel>
            <RoundResultModal
                visible={modalVisible}
                correct={isCorrect}
                round={round}
                totalRounds={EXTENDED_TOTAL_ROUNDS}
                onNext={advanceRound}
                onShowResult={showFinal}
                wrongVerdict={selectedAnswer ? `${selectedAnswer} není správná odpověď :(` : null}
            >
                <h3>Správná odpověď</h3>
                <p>
                    <strong style={{ fontSize: '1.2em' }}>{question.city.obec}</strong>
                    <br />
                    okres {question.city.okres}, {question.city.kraj}
                </p>
                {selectedAnswer && !isCorrect && (
                    <p>
                        Tvůj tip byl: <strong>{selectedAnswer}</strong>.
                    </p>
                )}
            </RoundResultModal>
        </>
    );
};

export const MunicipalityRegion = () => (
    <Content>
        <Page>
            <Header>
                <BackToModesLink />
                <h1>Obec → kraj a okres</h1>
                <p>
                    Dostaneš jméno české obce a hádáš, do kterého kraje nebo okresu patří. Pět kol, čtyři možnosti v
                    každém. Data: RSO obcí ČSÚ.
                </p>
            </Header>
            <MunicipalityRegionGame />
        </Page>
    </Content>
);
